import { OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
var DisclaimerComponent = /** @class */ (function () {
    function DisclaimerComponent(domSanitizer) {
        this.domSanitizer = domSanitizer;
        this.icon = 'info';
    }
    DisclaimerComponent.prototype.ngOnInit = function () {
        this.message = this.domSanitizer.bypassSecurityTrustHtml(this.message);
    };
    return DisclaimerComponent;
}());
export { DisclaimerComponent };
